import { whenAdapterReady } from './whenAdapterReady';
import { whenTrackCompleted } from './whenTrackCompleted';
import { publish } from '../message-bus';
import { ANALYTICS_TRACKING_TIMEOUT, TRACKING_EVENT_NAME, MB_EVENT_PARTIAL } from '../consts';
export const doTrack = ({ index, title }) => {
    return new Promise((resolve) => {
        // in case of adapter issues resolve promise in fixed time.
        const timeout = window.setTimeout(resolve, ANALYTICS_TRACKING_TIMEOUT);
        const trackData = {
            event: TRACKING_EVENT_NAME,
            payload: {
                NonInteractionEvent: '0',
                EventCategory: 'Menu Interactions',
                EventAction: 'Banners',
                EventLabel: title ? title : null,
                ElementType: 'Standard',
                NavigationPosition: `${index}`,
                FeatureDescription: title ? title : null,
            },
        };
        whenAdapterReady(() => {
            publish({ topic: MB_EVENT_PARTIAL, data: trackData });
            whenTrackCompleted({ resolve, trackData, timeout });
        });
    });
};
